import {boot} from 'quasar/wrappers'
import {applyHandoffState, consumeHandoff} from 'src/classes/ActionResultHandoff.js'

// #897: take over the one-time route state of a resultset action result opened in a new tab.
// Boot files run before the router's initial navigation, which keeps existing history.state entries.
export default boot(() => {
  try {
    applyHandoffState(window, consumeHandoff(window))
  } catch (e) {
    console.warn('action result handoff could not be applied')
  }
})
